export type PublicVenuePost = {
  id: string;
  title: string;
  body: string;
  cover: null | { id: string; url: string; thumbnail_url: string | null };
  published_at: string | null;
  content_version: number;
  venue: {
    id: string;
    name: string | null;
    avatar_url: string | null;
  };
};

type Envelope<T> = { data: T };
export type PublicVenuePostsPage = {
  data: PublicVenuePost[];
  meta: { current_page: number; last_page: number; per_page: number; total: number };
};

async function request<T>(url: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(url, {
    signal,
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`Post API failed: ${response.status}`);
  return response.json() as Promise<T>;
}

export function fetchPost(postId: string, signal?: AbortSignal): Promise<PublicVenuePost> {
  return request<Envelope<PublicVenuePost>>(`/api/v1/posts/${encodeURIComponent(postId)}`, signal)
    .then((response) => response.data);
}

export function fetchVenuePosts(venueId: string, page = 1, perPage = 20, signal?: AbortSignal): Promise<PublicVenuePostsPage> {
  const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
  return request<PublicVenuePostsPage>(`/api/v1/venues/${encodeURIComponent(venueId)}/posts?${params.toString()}`, signal);
}
